import styled from 'styled-components'
import { Colors, Spacing, Typography } from 'cio-design-library/design-tokens'
import { FontWeights } from 'builder/styles/typography'
import { ButtonV2 } from 'builder/components/Button'
import ModalOverlay from 'builder/components/ModalOverlay'
import {
  Content as ContentStyle,
  Overlay as OverlayStyle,
} from 'builder/components/ModalOverlay/styles'
import Media from 'builder/styles/media'

export const ModalContainer = styled.div`
  ${OverlayStyle} {
    ${Media.Phone`
      align-items: flex-end;
    `}
  }

  ${ContentStyle} {
    ${Media.Phone`
        margin: unset;
    `}
  }
`

export const Modal = styled(ModalOverlay).attrs({
  backgroundOpacity: 0.2,
  overlayFadeDuration: 350,
  contentSlideDuration: 350,
})``

export const Container = styled.div`
  width: 352px;
  display: flex;
  padding: ${Spacing.M};
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: ${Spacing.M};
  background-color: ${Colors.White};
  border-radius: ${Spacing.XS};
  box-shadow: 0 6px 8px -2px rgba(15, 20, 30, 0.08), 0 16px 64px -8px rgba(15, 20, 30, 0.32);

  ${Media.Phone`
    width: 100%;
    padding: 12px 16px 16px;
  `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};

  ${Media.Phone`
    gap: ${Spacing['2XS']};
  `}
`

export const ImageContainer = styled.div`
  display: flex;
  width: 56px;
  height: 56px;
  padding: 0.7px 3.027px 0.7px 2.8px;
  justify-content: center;
  align-items: center;
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${Spacing['2XS']};

  ${Media.Phone`
    gap: ${Spacing['3XS']};
  `}
`

export const Title = styled.h1`
  ${Typography.sizes.Subhead};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`

export const Description = styled.p`
  ${Typography.sizes.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral70};
`

export const Action = styled(ButtonV2)`
  width: 100%;
`
